import { SDKResponse, ServerOptions } from '@commercetools/frontend-sdk';
import { AcceptedQueryTypes } from '@commercetools/frontend-sdk/lib/types/Query';
import { getCookieValue } from '@/helpers/utils/siteUtils';
import { sdk } from 'sdk';

export const callActionMiddleware = <ReturnData>(options: {
  actionName: string;
  payload?: unknown;
  query?: AcceptedQueryTypes;
  skipQueue?: boolean;
  customHeaderValue?: string;
  serverOptions?: ServerOptions;
}): Promise<SDKResponse<ReturnData>> => {
  const customHeaderValue = getCookieValue('sf_session_token') || '';
  options = { ...options, customHeaderValue };
  return sdk.callAction(options);
};
